import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InputListGuard } from './auth/input-list-guard';
import { LoginGuard } from './auth/login-guard';
import { HelpComponent } from './help/help.component';
import { CanDeactivateGuard } from './helper/can-deactivate/can-deactivate.guard';
import { MaintenanceModeComponent } from './helper/maintenance-mode/maintenance-mode.component';
import { HomeComponent } from './home/home.component';
import { ProjectInfoChecklistListComponent } from './project/project-info/checklist/checklist-list/checklist-list.component';
import { ProjectInfoChecklistModifyComponent } from './project/project-info/checklist/checklist-modify/checklist-modify.component';
import { ProjectInputTemplateCreateComponent } from './project/project-initial-information/checklist-template/project-input-template-create.component';
import { ProjectInitialInformationComponent } from './project/project-initial-information/project-initial-information.component';
import { ProjectScopingResultsComponent } from './project/project-initial-information/scoping-results/scoping-results.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { PlatformRedirectorComponent } from './header/topbar/platform-picker-dialog/platform-redirector.component';

// The actual routes
const APP_ROUTES: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  { path: 'logout', component: LogoutComponent },
  { path: 'maintenance', component: MaintenanceModeComponent },

  {
    path: 'project-input', component: ProjectInitialInformationComponent, canActivate: [LoginGuard], canDeactivate: [CanDeactivateGuard], children: [
      {
        path: 'create-template', component: ProjectInputTemplateCreateComponent, canActivate: [InputListGuard], canDeactivate: [CanDeactivateGuard], children: [
          { path: '', component: ProjectInfoChecklistListComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'new', component: ProjectInfoChecklistModifyComponent, canDeactivate: [CanDeactivateGuard], canActivate: [InputListGuard] },
          { path: 'edit/:index', component: ProjectInfoChecklistModifyComponent, canDeactivate: [CanDeactivateGuard], canActivate: [InputListGuard] },
        ]
      },
    ]
  },
  { path: 'scoping-results', component: ProjectScopingResultsComponent, canDeactivate: [CanDeactivateGuard], canActivate: [LoginGuard, InputListGuard] },
  { path: 'project', loadChildren: () => import('./project/project.module').then(m => m.ProjectModule), canActivate: [LoginGuard] },
  { path: 'results', loadChildren: () => import('./results/results.module').then(m => m.ResultsModule), canActivate: [LoginGuard] },
  { path: 'accadmin', loadChildren: () => import('./acc-admin/acc-admin.module').then(m => m.AccAdminModule), canActivate: [LoginGuard] },
  { path: 'home', component: HomeComponent, canActivate: [LoginGuard] },
  { path: 'help', component: HelpComponent, canActivate: [LoginGuard] },
  { path: 'redirect', component: PlatformRedirectorComponent },

  { path: '**', redirectTo: '/home' }
];
// End of the routes

@NgModule({
  imports: [
    RouterModule.forRoot(
      APP_ROUTES,
      { enableTracing: false }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
